import script from "./CustomerShowHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerShowHeader.vue?vue&type=script&setup=true&lang=js"

import "./CustomerShowHeader.vue?vue&type=style&index=0&id=a46bdbfc&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a46bdbfc"]])

export default __exports__